import React from 'react';
import { FCWithChildren } from '../lib/types';

interface HeadingProps {
  className?: string;
  pageName: string;
}

export const Heading: FCWithChildren<HeadingProps> = ({
  children,
  className = '',
  pageName = '',
}) => {
  return (
    <h1
      className={`font-extrabold text-blackberry text-3xl mb-4 leading-10 ${className}`}
      data-testid={`${pageName}-heading`}
      id="modal-headline"
    >
      {children}
    </h1>
  );
};
